import type React from 'react';
import type { IconBaseProps, IconType } from 'react-icons';
import {
  LuActivity as _LuActivity,
  LuBitcoin as _LuBitcoin,
  LuBell as _LuBell,
  LuChartArea as _LuChartArea,
  LuChartBar as _LuChartBar,
  LuChartCandlestick as _LuChartCandlestick,
  LuCalendarClock as _LuCalendarClock,
  LuCloudSun as _LuCloudSun,
  LuShieldCheck as _LuShieldCheck,
  LuMegaphone as _LuMegaphone,
  LuSpline as _LuSpline,
  LuCalendarCheck as _LuCalendarCheck,
  LuChartLine as _LuChartLine,
  LuChartNoAxesColumn as _LuChartNoAxesColumn,
  LuChevronRight as _LuChevronRight,
  LuCornerDownLeft as _LuCornerDownLeft,
  LuGauge as _LuGauge,
  LuGitCompare as _LuGitCompare,
  LuGrid2X2 as _LuGrid2X2,
  LuGrid3X3 as _LuGrid3X3,
  LuHistory as _LuHistory,
  LuLanguages as _LuLanguages,
  LuLayers as _LuLayers,
  LuLayoutDashboard as _LuLayoutDashboard,
  LuLayoutGrid as _LuLayoutGrid,
  LuLayoutPanelLeft as _LuLayoutPanelLeft,
  LuLayoutTemplate as _LuLayoutTemplate,
  LuListChecks as _LuListChecks,
  LuMonitor as _LuMonitor,
  LuPalette as _LuPalette,
  LuPanelLeftClose as _LuPanelLeftClose,
  LuPanelLeftOpen as _LuPanelLeftOpen,
  LuPanelRightClose as _LuPanelRightClose,
  LuPanelRightOpen as _LuPanelRightOpen,
  LuNewspaper as _LuNewspaper,
  LuPercent as _LuPercent,
  LuRadar as _LuRadar,
  LuScanLine as _LuScanLine,
  LuScanSearch as _LuScanSearch,
  LuSearch as _LuSearch,
  LuShuffle as _LuShuffle,
  LuSigma as _LuSigma,
  LuSlidersHorizontal as _LuSlidersHorizontal,
  LuSmartphone as _LuSmartphone,
  LuSparkles as _LuSparkles,
  LuStar as _LuStar,
  LuTable2 as _LuTable2,
  LuTarget as _LuTarget,
  LuWaves as _LuWaves,
  LuZap as _LuZap,
} from 'react-icons/lu';

/**
 * Icon boundary for the MMEC chrome.
 *
 * react-icons v5 declares every icon as `IconType = (props) => ReactNode`.
 * TypeScript 4.9 (this project's compiler) only accepts a JSX element type
 * whose call signature returns `ReactElement | null`, so `<LuSearch />` is a
 * type error everywhere — even though it renders fine. Casting once here, at
 * the import boundary, keeps that quirk out of every component.
 *
 * Import icons from this module, never from 'react-icons/lu' directly.
 */
export type IconComponent = (props: IconBaseProps) => React.ReactElement | null;

const asIcon = (icon: IconType): IconComponent => icon as unknown as IconComponent;

export const LuActivity = asIcon(_LuActivity);
export const LuBitcoin = asIcon(_LuBitcoin);
export const LuBell = asIcon(_LuBell);
export const LuChartArea = asIcon(_LuChartArea);
export const LuChartBar = asIcon(_LuChartBar);
export const LuChartCandlestick = asIcon(_LuChartCandlestick);
export const LuCalendarClock = asIcon(_LuCalendarClock);
export const LuCloudSun = asIcon(_LuCloudSun);
export const LuShieldCheck = asIcon(_LuShieldCheck);
export const LuMegaphone = asIcon(_LuMegaphone);
export const LuSpline = asIcon(_LuSpline);
export const LuCalendarCheck = asIcon(_LuCalendarCheck);
export const LuChartLine = asIcon(_LuChartLine);
export const LuChartNoAxesColumn = asIcon(_LuChartNoAxesColumn);
export const LuChevronRight = asIcon(_LuChevronRight);
export const LuCornerDownLeft = asIcon(_LuCornerDownLeft);
export const LuGauge = asIcon(_LuGauge);
export const LuGitCompare = asIcon(_LuGitCompare);
export const LuGrid2X2 = asIcon(_LuGrid2X2);
export const LuGrid3X3 = asIcon(_LuGrid3X3);
export const LuHistory = asIcon(_LuHistory);
export const LuLanguages = asIcon(_LuLanguages);
export const LuLayers = asIcon(_LuLayers);
export const LuLayoutDashboard = asIcon(_LuLayoutDashboard);
export const LuLayoutGrid = asIcon(_LuLayoutGrid);
export const LuLayoutPanelLeft = asIcon(_LuLayoutPanelLeft);
export const LuLayoutTemplate = asIcon(_LuLayoutTemplate);
export const LuListChecks = asIcon(_LuListChecks);
export const LuMonitor = asIcon(_LuMonitor);
export const LuPalette = asIcon(_LuPalette);
export const LuPanelLeftClose = asIcon(_LuPanelLeftClose);
export const LuPanelLeftOpen = asIcon(_LuPanelLeftOpen);
export const LuPanelRightClose = asIcon(_LuPanelRightClose);
export const LuPanelRightOpen = asIcon(_LuPanelRightOpen);
export const LuNewspaper = asIcon(_LuNewspaper);
export const LuPercent = asIcon(_LuPercent);
export const LuRadar = asIcon(_LuRadar);
export const LuScanLine = asIcon(_LuScanLine);
export const LuScanSearch = asIcon(_LuScanSearch);
export const LuSearch = asIcon(_LuSearch);
export const LuShuffle = asIcon(_LuShuffle);
export const LuSigma = asIcon(_LuSigma);
export const LuSlidersHorizontal = asIcon(_LuSlidersHorizontal);
export const LuSmartphone = asIcon(_LuSmartphone);
export const LuSparkles = asIcon(_LuSparkles);
export const LuStar = asIcon(_LuStar);
export const LuTable2 = asIcon(_LuTable2);
export const LuTarget = asIcon(_LuTarget);
export const LuWaves = asIcon(_LuWaves);
export const LuZap = asIcon(_LuZap);
